<template>
  <div class="pb100">
    <banner/>
    <crumbs/>
    <div class="container">
        <ul class="digread">
            <li><img src="../../assets/common/images/pic01.jpg"></li>
            <li class="dbt">
                <a href="http://yz4.chaoxing.com/common/pc/book_index" target="_blank"><i class="num01">-1-</i><span>图书</span></a>
            </li>
            <li><img src="../../assets/common/images/pic02.jpg"></li>
            <li class="dbt">
                <a href="http://qk.chaoxing.com/space/index" target="_blank"><i class="num02">-2-</i><span>期刊</span></a>
            </li>
            <li class="dbt">
                <a href="http://qk.chaoxing.com/npspace/index" target="_blank"><i class="num03">-3-</i><span>报纸</span></a>
            </li>
            <li><img src="../../assets/common/images/pic03.jpg"></li>
            <li class="dbt">
                <a href="http://yz4.chaoxing.com/common/pc/subjectAction/index?fid=3878" target="_blank"><i class="num04">-4-</i><span>专题</span></a>
            </li>
            <li><img src="../../assets/common/images/pic04.jpg"></li>
        </ul>
    </div>
  </div>
</template>
<script>

import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
export default {
  name: 'digit',
  meta: {
    showHeader: true
  },
  components: {
    crumbs,
    banner
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.digread{
  overflow:hidden;
  padding:50px 10px 50px;
  li{
    float:left;
    width:25%;
    height:200px;
    img{
      display:block;
      width:100%;
      height:100%;
    }
    a{
      display:block;
      height:100%;
      background:#f2f2f2;
      overflow:hidden;
      color:#6085cb;
      letter-spacing:3px;
      &:hover{
        background:#b90b13;
        color:#fff;
        -webkit-box-shadow: 0 0 10px #ccc;
        -webkit-animation: toRedBg 0.8s 1 ease;
        -moz-animation: toRedBg 0.8s 1 ease;
        animation: toRedBg 0.8s 1 ease;
        i{
          color:rgba(255,255,255,.7);
        }
      }
    }
    &.dbt{
      text-align:center;
      position:relative;
      i{
        display:block;
        height:46px;
        line-height:44px;
        margin:50px auto 0;
        color:#bfbfbf;
        font-style:normal;
        font-size:46px;
        font-weight:lighter;
        letter-spacing:5px;
      }
      span{
        display:block;
        font-size:22px;
        padding:15px 0 0;
      }
      &:hover{
        -moz-box-shadow: 0 0 10px #aaa;
        -webkit-box-shadow:  0 0 10px #aaa;
        box-shadow:0 0 10px #aaa;
        -webkit-animation: shadow 0.8s 1 ease;
        -moz-animation: shadow 0.8s 1 ease;
        animation: shadow 0.8s 1 ease;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/digit/index.vue